import React, { useEffect, useState } from 'react'
import Modal from 'components/Modal/Modal';
import { Link } from 'react-router-dom';
import { FiEye } from "react-icons/fi"
import axios from 'axios';
import { Config } from "../../config"
import { getParameterByVehilce } from '../../features/report/reportSlice';
import { useDispatch, useSelector } from 'react-redux';

const Reports = ({ searchTerm }) => {

    // console.log("searchTerm::: ", searchTerm)

    const dispatch = useDispatch()
    const [showModal, setShowModal] = React.useState(false);
    const [reports, setReports] = React.useState([]);

    const { user } = useSelector((state) => state.auth);
    const { userId, jwtToken } = user;

    const config = {
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        },
    }

    // User TestSession Data:
    const getUserReports = async (id) => {
        try {
            const response = await axios.get(`${Config.API_URL}/test-session/userId/${id}`, config);
            console.log("User Reports ========== ", response.data);
            if (response.status === 200) {
                setReports(response.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function handleShow(item) {
        dispatch(getParameterByVehilce(item));
        setShowModal(true);
    }

    function convertToEST(unixTime) {
        const date = new Date(unixTime * 1000);
        const options = {
            timeZone: 'America/New_York',
            day: 'numeric',
            year: 'numeric',
            month: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        };
        return date.toLocaleDateString('en-US', options);
    }


    useEffect(() => {
        getUserReports(userId)
    }, [])

    return (
        <>
            <div className="flex flex-col mb-20">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-4 inline-block min-w-full sm:px-6 lg:px-8">
                        <div className="overflow-hidden">
                            <table className="min-w-full text-center">
                                <thead className="border-b bg-gray-50">
                                    <tr>
                                        <th scope="col" className="text-sm font-semibold text-gray-900 px-6 py-4">
                                            Sr. No
                                        </th>
                                        <th scope="col" className="text-sm font-semibold text-gray-900 px-6 py-4">
                                            User Name
                                        </th>
                                        <th scope="col" className="text-sm font-semibold text-gray-900 px-6 py-4">
                                            Year
                                        </th>
                                        <th scope="col" className="text-sm font-semibold text-gray-900 px-6 py-4">
                                            Make
                                        </th>
                                        <th scope="col" className="text-sm font-semibold text-gray-900 px-6 py-4">
                                            Model
                                        </th>
                                        <th scope="col" className="text-sm font-semibold text-gray-900 px-6 py-4">
                                            Test date
                                        </th>
                                        <th scope="col" className="text-sm font-semibold text-gray-900 px-6 py-4">
                                            VIN
                                        </th>
                                        <th scope="col" className="text-sm font-semibold text-gray-900 px-6 py-4 text-end">
                                            View report
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reports.length > 0 ? reports.filter((item) => {
                                        if (searchTerm === "") {
                                            return item;
                                        } else if (
                                            item?.VIN?.vin?.toString()
                                                .toLocaleLowerCase()
                                                .includes(searchTerm.toLocaleLowerCase())
                                        ) {
                                            return item;
                                        }
                                    }).map((item, index) => {
                                        return (
                                            <tr key={index} className="bg-white border-b">
                                                <td className="text-sm text-gray-900 font-normal px-6 py-4 whitespace-nowrap">
                                                    {index + 1}
                                                </td>
                                                <td className="text-sm text-gray-900 font-normal px-6 py-4 whitespace-nowrap">
                                                    {item?.generatedBy?.role === 'IndividualUser' ? item?.generatedBy?.firstName + " " + item?.generatedBy?.lastName : null}
                                                </td>
                                                <td className="text-sm text-gray-900 font-normal px-6 py-4 whitespace-nowrap">
                                                    {item?.VIN?.year}
                                                </td>
                                                <td className="text-sm text-gray-900 font-normal px-6 py-4 whitespace-nowrap">
                                                    {item?.VIN?.VehicleMake?.make}
                                                </td>
                                                <td className="text-sm text-gray-900 font-normal px-6 py-4 whitespace-nowrap">
                                                    {item?.VIN?.VehicleModel?.model}
                                                </td>
                                                <td className="text-sm text-gray-900 font-normal px-6 py-4 whitespace-nowrap">
                                                    {convertToEST(item.testDate)}
                                                </td>
                                                <td className="text-sm text-gray-900 font-normal px-6 py-4 whitespace-nowrap">
                                                    {item.VIN?.vin || '-'}
                                                </td>
                                                <td className="text-sm text-gray-900 font-semibold px-6 py-4 whitespace-nowrap text-end">
                                                    <button onClick={() => handleShow(item)} className="bg-[#25C454] text-white py-2 px-3 rounded">
                                                        <span className='flex items-center justify-center'>
                                                            <FiEye className='mr-1.5' size={16} /> View report
                                                        </span>
                                                    </button>
                                                </td>

                                            </tr>
                                        );
                                    }) :
                                        <tr className='mt-5' >
                                            <td colSpan={5}>No Data Available!</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
            {/* Modal */}
            {showModal ? (
                <>
              
            
                
                    <div className="justify-center  flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[1050] outline-none focus:outline-none">
            
            
                        <div className="relative w-auto my-6 mx-auto ">
            
                            {/* <div className="border-0 rounded-lg  relative flex flex-col w-full bg-white outline-none focus:outline-none"> */}
                            <Modal setShowModal={setShowModal} />
                            {/* <LowSOC />
                            </div> */}
                       </div>  
                     </div> 
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                   
                </>
            ) : null}
        </>
    )
}

export default Reports
